'use client'

import { createTheme, ThemeProvider } from '@mui/material'

//define colors
const palette = {
  defaultChannel: '12 12 12',
  primary: {
    light: '#b7b9d0',
    lighter: 'rgba(6, 32, 89, .1)',
    main: '#062058',
    dark: '#011835',
  },
  secondary: {
    main: '#79b93e',
    light: '#C9E3B2'
  },
  tertiary: {
    main: '#B85967',
    dark: '#8F455C'
  },
  quaternary: {
    main: '#43BFD9',
  },
  gray: {
    light: '#D9D9D9',
    main: '#808184',
    dark: '#4D4D4D',
  }
}

const fontWeightSemiBold = 600

//reference theme
const themeZero = createTheme({ palette })

//theme options
const themeOptions = {
  palette: {
    ...palette,
    background: {
      default: '#fff',
    },
  },
  fontWeightSemiBold: 600,
  //typography styles
  typography: {
    fontFamily: 'Nunito Variable, Sofia Sans Variable',
    fontVariantLigatures: 'none',
    body1: {
      marginBottom: themeZero.spacing(2),
    },
    h1: {
      fontSize: '4.0625rem',
      lineHeight: 1.09,
      fontWeight: themeZero.typography.fontWeightBold,
    },
    h2: {
      color: themeZero.palette.primary.main,
      fontSize: '1.625rem',
      lineHeight: 1.3,
      fontWeight: themeZero.typography.fontWeightBold,
      marginBottom: themeZero.spacing(2),
      '&:not(:first-of-type)': {
        marginTop: themeZero.spacing(4)
      }
    },
    h3: {
      fontSize: '1.125rem',
      fontWeight: themeZero.typography.fontWeightBold,
      marginBottom: themeZero.spacing(2)
    },
    h4: {
      fontSize: '1.25rem',
    },
    h5: {
      fontSize: '1.4375rem',
      fontWeight: themeZero.typography.fontWeightBold,
    },
    caption: {
      fontSize: '0.875rem',
      lineHeight: 1.3
    },
    nav: {
      fontSize: '.8125rem',
    },
    subNav: {
      fontSize: '.8125rem',
    },
    eyebrow: {
      fontWeight: themeZero.typography.fontWeightMedium
    },
    chartHeader: {
      fontSize: '1.25rem',
      lineHeight: 1.3,
      fontWeight: themeZero.typography.fontWeightBold,
      textAlign: 'center',
      color: themeZero.palette.primary.main,
      display: 'block'
    },
    th: {
      fontSize: '1.125rem',
      lineHeight: 1.3,
      color: themeZero.palette.primary.main,
      fontWeight: themeZero.typography.fontWeightBold,
      textAlign: 'center',
      '&:first-of-type': {
        textAlign: 'left',
      }
    },
    td: {
      fontSize: '1rem',
      lineHeight: 1.3,
      textAlign: 'center',
      '&:first-of-type': {
        textAlign: 'left',
        fontWeight: fontWeightSemiBold,
      }
    },
    endMatter: {
      color: '#062058'
    }
  },
}

export const theme = createTheme(themeOptions)
export const Theme = (props) => (<ThemeProvider theme={theme} {...props} />)

/* 

√ update theme colors
√ update button
√ update callout, add oval variant
√ update swoosh (delete)
√ update back to top
√ update chartbox
√ update pagedivider, with pecentage variants
√ update navigation and nav links
√ update pagebanner
√ update pagenav
√ update site map
√ update leaving modal
√ install fonts
√ update Accordion
√ container styles
√ update form, rename to connect-form
TODO UPDATE typography
TODO create resource box
*/